import React from 'react'
import PropTypes from 'prop-types'
import { QuesitonContentsContainer, QuestionBackgroundImage, QuestionContainer } from './styled'
import { Typography } from '@mui/material'

const QuestionListItem = (props) => {

    return <QuestionContainer answered={props.photoUrl} onClick={props.onClick}>
        { props.photoUrl ? <QuestionBackgroundImage answered={props.photoUrl} /> : null }
        <QuesitonContentsContainer>
            <Typography variant='h6'>{ props.question.title }</Typography>
            <Typography>{ props.note }</Typography>
        </QuesitonContentsContainer>
    </QuestionContainer>
}

QuestionListItem.propTypes = {
    question: PropTypes.object.isRequired,
    answer: PropTypes.object,
    photoUrl: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    note: PropTypes.string
}

export default QuestionListItem